import { createStore, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import reducer from './reducer';
import rootSaga from './rootSaga';

export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);

const middlewares = [routeMiddleware, sagaMiddleware];

export const store = createStore(
  connectRouter(history)(reducer),
  composeWithDevTools(applyMiddleware(...middlewares)),
);


sagaMiddleware.run(rootSaga);



// WEBPACK FOOTER //
// ./src/store.js